var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage-card-info-list-item text-body-2"},[_c('div',{staticClass:"content mr-2"},[_vm._t("default")],2),_c('div',{staticClass:"append"},[_vm._t("append")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }